$(function(){
  refreshCheckoutBtn();
  jscInitCartDrawerOverlay();
  cartJSEvent();
  jscInitCartDrawerQtyInputs();
  updateCountdownTimer();
  updateContentPosition();
  handleContentScroll();
  initKeyFeatureMobileSlider();
  updateMobileCardPos();
  initCustomProductSlider();
  initMobileProductSlider();
  designMode();
  jscInitCartState();
  onloadHideSizeVariant();

  if (location.href.includes('/products')) {
    initFlickityImageGallery();
    onloadSiblingsProducts();
  }
});

designMode = () => {
  if (Shopify.designMode) {
    $(document).on('shopify:section:load', function(event) {
      initCustomProductSlider();
      initMobileProductSlider();
    });
  }
}

refreshCheckoutBtn = () => {

  var myInterval = setInterval( function(){
    if ($('.checkout-buttons #update-cart').length > 0) {
      // console.log('refresh checkout btn');
      $('.checkout-buttons #update-cart').removeClass('aiod_checkout_clicked').addClass('aiod_cart_loaded').removeAttr('disabled');
      // clearInterval(myInterval);
    }
    $('.checkout-buttons #update-cart').addClass('aiod_cart_loaded');
  } , 5000);
}

//Start CartJS Function

var jscUpdateCartDrawerTimer = null;
var jscPendingCartRemovals = {};
var jscPendingCartRemovalMs = 1500;
var jscPromoProcessing = false;
var jscLastCartSnapshot = null;
var jscCartQtyDebounceTimers = {};
var jscCartOverlayBound = false;
var jscCartQtyDebounceMs = 400;
var jscPendingDrawerOpen = false;

jscInitCartState = () => {
  fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      jscLastCartSnapshot = {
        item_count: cart.item_count,
        total_price: cart.total_price
      };
      calculateProgress(cart);
      calculateProgressGWP(cart, { uiOnly: true });
      jscPromoProcessing = true;
      var promoMutated = masterPromo(false, cart);
      if (!promoMutated) {
        jscPromoProcessing = false;
      }
    });
};

jscThresholdCrossed = (prevTotal, currTotal, threshold) => {
  if (!threshold) {
    return false;
  }
  return (prevTotal < threshold && currTotal >= threshold) ||
    (prevTotal >= threshold && currTotal < threshold);
};

jscShouldRefreshCartGiftMarkup = (cart, previousSnapshot) => {
  if (!cart) {
    return false;
  }

  var snapshot = previousSnapshot || jscLastCartSnapshot;

  if (!snapshot) {
    return true;
  }
  if (cart.item_count !== snapshot.item_count) {
    return true;
  }

  var sgMin = parseInt($('.jsc-cart-freedelivery-section .cart-shipping__wrapper').attr('minprice-aud'), 10) || 0;
  var gwpMin = parseInt($('.jsc-cart-freegift-section .cart-shipping__wrapper').attr('minprice-aud'), 10) || 0;
  var prevTotal = snapshot.total_price;
  var currTotal = cart.total_price;

  return jscThresholdCrossed(prevTotal, currTotal, sgMin) ||
    jscThresholdCrossed(prevTotal, currTotal, gwpMin);
};

jscRefreshCartGiftMarkup = (callback) => {
  var $cartType = $('.jsc-cart-drawer-type').attr('data-cart-type');
  var $drawerType = $('.jsc-cart-drawer-type').attr('data-drawer-type');

  if ($cartType !== 'drawer' || $drawerType !== 'side-drawer') {
    if (callback) {
      callback();
    }
    return;
  }

  var $target = $('.jsc-cart-gift-markup');
  if ($target.length === 0) {
    if (callback) {
      callback();
    }
    return;
  }

  $.getJSON('/?sections=jsc-section-cart-drawer', function(data) {
    var sectionHtml = data && data['jsc-section-cart-drawer'];
    if (sectionHtml) {
      var $parsed = $('<div>').html(sectionHtml);
      var $newMarkup = $parsed.find('.jsc-cart-gift-markup');
      if ($newMarkup.length) {
        $target.html($newMarkup.html());
      } else {
        $target.empty();
      }
    }
    if (callback) {
      callback();
    }
  }).fail(function() {
    if (callback) {
      callback();
    }
  });
}

jscGetDrawerUpdateOptions = (extraOptions) => {
  var options = extraOptions || {};
  if (jscPendingDrawerOpen) {
    options.openAfterRender = true;
  }
  return options;
};

cartJSEvent = () => {
  $(document).on('cart.requestComplete', function(event, cart) {
    $('.jsc-page-loading').remove();

    if (jscPromoProcessing) {
      jscUpdateCartDrawer(cart, jscGetDrawerUpdateOptions());
      jscPromoProcessing = false;
      return;
    }

    if (jscPendingDrawerOpen) {
      jscUpdateCartDrawer(cart, jscGetDrawerUpdateOptions());

      setTimeout(function() {
        var runDeferredPromo = function() {
          jscPromoProcessing = true;
          var promoMutated = masterPromo(true, cart);
          if (!promoMutated) {
            jscPromoProcessing = false;
          }
        };

        // Server-rendered gift markup must refresh after add-to-cart so cart-type GWP rules run.
        jscRefreshCartGiftMarkup(runDeferredPromo);
      }, 0);

      return;
    }

    var finishCartUpdate = function() {
      jscPromoProcessing = true;
      var promoMutated = masterPromo(true, cart);
      if (!promoMutated) {
        jscPromoProcessing = false;
        jscUpdateCartDrawer(cart, jscGetDrawerUpdateOptions());
      }
    };

    if (jscShouldRefreshCartGiftMarkup(cart)) {
      jscRefreshCartGiftMarkup(finishCartUpdate);
    } else {
      finishCartUpdate();
    }
  });
  $(document).on('cart.requestStarted', function(event, cart) {
    if (location.href.includes('/cart')) {
      var $html = `<div class="jsc-page-loading">
                  <div class="jsc-spinner-container">
                    <div class="jsc-loading-text">Updating your cart...</div>
                  </div>
                </div>`;
      $('body').prepend($html);
    }
  });
}

jscResetPendingDrawerOpen = () => {
  jscPendingDrawerOpen = false;
  $('.jsc-cart-drawer-div').removeClass('jsc-cart-updating');
};

cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
  CartJS.addItem(vid, qty, obj,
  {
    "success": function(data, textStatus, jqXHR) {
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
      jscResetPendingDrawerOpen();
    }
  });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
  CartJS.updateItemById(vid, qty, obj,
  {
    "success": function(data, textStatus, jqXHR) {

      if (location.href.includes('/cart')) {
        if (!data.item_count) {
          $(".jsc-cart-container").load(location.href+" .jsc-cart-container>*","");
        }
      }
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
      jscResetPendingDrawerOpen();
    }
  });
}
//End CartJS Function

//Start Master Promo Function
masterPromo = (isDrawer, cart) => {
  var mutated = gwpFunction(isDrawer, cart);
  if (jscEvaluateCartGwpThreshold(cart)) {
    mutated = true;
  }
  if (cartGift()) {
    mutated = true;
  }
  return mutated;
}

//Start GWP promo
gwpFunction = (isOpenDrawer, cart) => {
  var mutated = false;
  var $gwpcart_product = {};
  var $addEle = $('.jsc-add-gwp');
  var $updateEle = $('.jsc-update-gwp');
  var $deleteEle = $('.jsc-remove-gwp');

  $gwpcart_product['_Promo'] = 'Free Gift';

  $addEle.each(function() {
    var $vid = parseInt($(this).val(), 10);
    var $qty = parseInt($(this).attr('data-qty'), 10);

    $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');
    cartJSAddQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    mutated = true;
  });

  $updateEle.each(function() {
    var $vid = $(this).val();
    var $qty = parseInt($(this).attr('data-qty'), 10);

    $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');
    cartJSUpdateQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    mutated = true;
  });

  $deleteEle.each(function() {
    var $vid = $(this).val();
    cartJSUpdateQuery($vid, 0, {}, isOpenDrawer);
    mutated = true;
  });

  return mutated;
}
//End GWP promo
//Start GWP based on cart, product or collection promo
cartGift = () => {
  var mutated = false;
  if (addCartGift()) {
    mutated = true;
  }
  if (removeCartGift()) {
    mutated = true;
  }
  return mutated;
}

addCartGift = () => {
  var mutated = false;
  var $elem = $('.jsc-cart-gift');
  var removeGift = sessionStorage.getItem("FreeGift");

  $elem.each(function() {
    var $vid = parseInt($(this).val(), 10);
    var $obj = {};
    var $promoNo = $(this).attr('data-promo');

    $obj['_Cart_Gift'] = $promoNo;
    $obj['_Cart_GWP'] = 'Free Gift';
    if (removeGift != 'Remove') {
      cartJSAddQuery($vid, 1, $obj, true);
      mutated = true;
    }
  });
  return mutated;
}

removeCartGift = () => {
  var mutated = false;
  var $elem = $('.jsc-cart-gift-remove');

  $elem.each(function() {
    var $key = $(this).val();
    if ($key) {
      cartJSUpdateQuery($key, 0, {}, true);
      mutated = true;
    }
  });
  return mutated;
}

jscEvaluateCartGwpThreshold = (cart) => {
  var freeGiftSection = $('.jsc-cart-freegift-section');
  if (!cart || freeGiftSection.length === 0) {
    return false;
  }

  var cartMinVal = parseInt(freeGiftSection.find('.cart-shipping__wrapper').attr('minprice-aud'), 10);
  var freeItemId = freeGiftSection.find('.cart-shipping__wrapper').attr('data-item-id');
  if (!cartMinVal || !freeItemId) {
    return false;
  }

  var isGwpInCart = false;
  for (var i = 0; i < cart.items.length; i++) {
    var item = cart.items[i];
    var itemGwpProp = item.properties && item.properties['_Cart_GWP'];
    var itemGwpPropPromo = item.properties && item.properties['_Cart_Gift'];
    if (String(freeItemId) == String(item.id) && itemGwpProp == 'Free Gift' && String(itemGwpPropPromo) == '1') {
      isGwpInCart = true;
      break;
    }
  }

  var mutated = false;
  if (cart.total_price >= cartMinVal) {
    if (!isGwpInCart && sessionStorage.getItem("FreeGift") != 'Remove') {
      if ($('.jsc-cart-items-section .jsc-cart-gift').length === 0) {
        $('.jsc-cart-items-section').append(
          '<input type="hidden" value="' + freeItemId + '" class="jsc-cart-gift" data-promo="1">'
        );
        mutated = true;
      }
    } else {
      $('.jsc-cart-items-section .jsc-cart-gift').remove();
    }
  } else if (isGwpInCart) {
    if ($('.jsc-cart-items-section .jsc-cart-gift-remove.jsc-promo-1').length === 0) {
      var giftLineKey = null;
      for (var j = 0; j < cart.items.length; j++) {
        var gwpItem = cart.items[j];
        if (String(gwpItem.id) == String(freeItemId)) {
          giftLineKey = gwpItem.key;
          break;
        }
      }
      if (giftLineKey) {
        $('.jsc-cart-items-section').append(
          '<input type="hidden" value="' + giftLineKey + '" class="jsc-cart-gift-remove jsc-promo-1">'
        );
        mutated = true;
      }
    }
  }

  return mutated;
}

removeFreeGift = (e,varID) =>{
  // this function is used to remove gwp item in cart using sessionStorare. the gwp can only be re-added when browser is restarted
  sessionStorage.setItem("FreeGift", "Remove");
  //console.log(varID);
  cartJSUpdateQuery(varID, 0);
}
//End GWP based on cart, product or collection promo

//start: hover grid
jscHoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').removeClass('d-none');
  }
}
jscOuthoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').addClass('d-none');
  }
}
//end: hover grid

jscCollFilter = (e) => {
  
  var $thisFilter = $(e).parents('.link-dropdown');
  var $otherFilter = $thisFilter.siblings('.link-dropdown');
  var $dropdownWidth = $(e).siblings('.link-dropdown__options').width();
  console.log($dropdownWidth);
  // setTimeout(function(){},500);
    $(e).css('width',$dropdownWidth);
  
  

  $otherFilter.each(function(){
    $(this).find('.link-dropdown__button').attr('aria-expanded','false'); // to allow 1 filter open at a time
    $(this).find('.link-dropdown__button').css('width','fit-content');
    // console.log($(this));
  });
}

//start: pdp atc
jscClickATC = () => {
  var $cartDrawerType = $('.jsc-cart-drawer-type').attr('data-drawer-type');
  var $cartType = $('.jsc-cart-drawer-type').attr('data-cart-type');
  //console.log('$cartDrawerType',$cartDrawerType,'$cartType',$cartType);

  if ($cartType == 'drawer') {
    if ($cartDrawerType == 'top-drawer') {
      setTimeout(function(){
        var $cart_drawer = $('#cart-summary-overlay');
        if ($cart_drawer.length > 0) {
          console.log('close cart drawer2');
          $cart_drawer.css({
            transform: 'translateY(-100%)',
            transition: 'transform ease-out 0.5s'
          });
          // $cart_drawer.remove();
        }
      },5000);
    } else {
      var pageUrl = window.location.href;
      var varID = pageUrl.split('variant=')[1];
      jscUpdateCartDrawer(varID);
      $('#cart-summary-overlay').css({
        display: 'none'
      })
    }
  }
  
  // setTimeout(function(){
  //   jscOpenCartDrawer();
  // },500);
}
jscCustomATC = (e) => {
  var $form = $(e).closest('form');

  if (!$form[0].checkValidity()) {
    $form[0].reportValidity();
    return;
  }

  var varID = $form.find('[name="id"]').val();
  var properties = {};
  var $giftCardCheckbox = $form.find('input[name="properties[__shopify_send_gift_card_to_recipient]"]');

  if ($giftCardCheckbox.length > 0 && $giftCardCheckbox.is(':checked')) {
    $form.find('[name^="properties["]').each(function() {
      var $input = $(this);
      var propName = $input.attr('name').replace('properties[', '').replace(']', '');
      properties[propName] = $input.val();
    });
  }

  $('.jsc-cart-drawer-div').addClass('jsc-cart-updating');
  jscPendingDrawerOpen = true;
  jscOpenCartDrawer();
  cartJSAddQuery(varID, 1, properties, true);
};
//end 

onloadSiblingsProducts = () => {
  var $prod_details = $('.jsc-prod-json-details').find('.jsc-each-prod-json');
  var $prod_sibs_container = $('.jsc-sibling-products-content');
  var $prod_sibs_grid = $prod_sibs_container.find('.jsc-each-colour-url');
  var $current_url = window.location.href;
  // console.log($current_url);

  $prod_details.each(function(){
    var $this_graphql = $(this).attr('data-graphql');
    // console.log($this_graphql);

        // Define your GraphQL query

        const graphqlQuery = `
        query {
          product(id: "` + $this_graphql + `") {
            id
            title
            handle
            variants(first: 10) {
              edges {
                node {
                  title
                }
              }
            }
            featuredImage {
              id
              src
            }
          }
        }
        `;
        
        // Set the endpoint URL
        const endpointUrl = 'https://foxwood-clothing.myshopify.com/api/2023-10/graphql.json';

        // Send the GraphQL request using jQuery
        $.ajax({
          url: endpointUrl,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '8d93c93237708dffc053eb9c21c10ace', 
          },
          data: JSON.stringify({ query: graphqlQuery }),
          success: function(response) {
            // Handle the response here
            // console.log('Result',response);
            var prod_title = response.data.product.title;
            var prod_handle = response.data.product.handle;
            var prod_img = response.data.product.featuredImage.src;
            // var prod_url = 'https://www.foxwoodclothing.com.au/products/' + prod_handle;
            var prod_url = '/products/' + prod_handle;
            var variant_title = response.data.product.variants.edges[0].node.title;
            var variant_color = variant_title.split(" / ");
            var type_tab;
            var var_color = '';

            if (variant_color[0] !== undefined ) {
              var_color = variant_color[0];
            } else {
              var_color = '';
            }
            var color_handle = var_color.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

            if ($current_url.includes(color_handle) && var_color != '') {
              // console.log('active',color_handle);
              type_tab = 'jsc-active-col';
            } else {
              // console.log('inactive',color_handle);
              type_tab = 'jsc-inactive-col';
            }
            // console.log(type_tab,color_handle);
            
            var $color_grid = '<a href="' + prod_url + '" class="jsc-each-colour-url"><div class="jsc-each-colour-prod ' + type_tab + '"><img class="jsc-each-colour-prod-img" src="' + prod_img + '" alt="' + prod_title +'"></div><span>' + var_color + '</span></a>';
            // console.log($color_grid);
            // $prod_sibs_container.append($color_grid);

            $prod_sibs_grid.each(function(){
              var $thisGraphql = $(this).attr('data-graphql');
              var $thisUrl;
              var $thisColor = $(this).find('span');
              var $thisColorImg = $(this).find('.jsc-each-colour-prod-img');             

              if ($thisGraphql == $this_graphql) {
                // console.log($color_grid);
                $thisUrl = $(this).attr("href",prod_url);
                $thisColor.text(var_color);
                $thisColorImg.attr("src",prod_img);
                $thisColorImg.attr("alt",prod_title);
                
                $(this).addClass(type_tab);
                $(this).removeClass('d-none');
                
              }
            });
          },
          error: function(error) {
            // Handle any errors here
            console.error('Error!',error);
          }
        });
  });


  
}

jscSelectVariant = (e, isGiftCard = false) => {
  setTimeout(function(){
    var $selected_size = $(e).attr('value');
    if (isGiftCard) {
      $selected_size = $selected_size.replace('.00', '');
    }
    $('.jsc-selected-variant').text($selected_size);
    var $var_unavailable = $(e).next().hasClass('unavailable');

    if ($var_unavailable == true) {
      $('.jsc-buy-buttons-row').addClass('jsc-oos-button');
      $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger.d-none').removeClass('d-none');
    } else {
      $('.jsc-buy-buttons-row').removeClass('jsc-oos-button');
      $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').addClass('d-none');
    }
  }, 200)
  
}

// start: countdown timer
updateCountdownTimer = () => {
  var $countdownTimer = $('.jsc-countdown-timer-container .jsc-countdown-timer');
  if($countdownTimer.length > 0) {
    $countdownTimer.each(function() {
      var intervalID = setInterval(() => {
        var targetTime = new Date($(this).attr('data-end-date'));
        var timeZoneOffset = parseInt($(this).attr('data-timezone-offset').replace('+', '').slice(0, -2));
        var now = new Date();
        var nowOffset = now.getTimezoneOffset();
        var timeZoneOffsetMin = timeZoneOffset * 60;
        var offsetDiff = timeZoneOffsetMin + nowOffset;
        var localNowDate = new Date(now.getTime() + offsetDiff * 60000);
        var timeRemaining = targetTime - localNowDate;
  
        if (timeRemaining <= 0) {
          clearInterval(intervalID);
          var isHideOnEnd = $(this).attr('data-hide-on-end');
          if (isHideOnEnd == 'true') {
            $(this).removeClass('active');
          }
          $(this).siblings('.jsc-timer-end-text').addClass('active');
          return;
        }
  
        var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
  
        $(this).find('.jsc-timer-day').text(addLeadingZero(days));
        $(this).find('.jsc-timer-hour').text(addLeadingZero(hours));
        $(this).find('.jsc-timer-minute').text(addLeadingZero(minutes));
        $(this).find('.jsc-timer-second').text(addLeadingZero(seconds));      
      }, 1000);
    });
  }
}

addLeadingZero = (number) => {
  return number < 10 ? '0' + number : number;
}
// end: countdown timer

// start: key feature
updateContentPosition = () => {
  var $keyFeatureWrapper = $('.jsc-key-feature-wrapper');
  if($keyFeatureWrapper.length > 0) {
    var $firstMedia = $keyFeatureWrapper.find('.jsc-img-col .jsc-key-feature-media-item[data-index="1"] .jsc-media-box');
    var mediaHeight = $firstMedia.height();
    var $currentContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item.active');
    var contentHeight = $currentContent.height();

    var paddingTop = (mediaHeight / 2) - (contentHeight / 2);
    $currentContent.css('padding-top', paddingTop + 'px');
  }
}

handleContentScroll = () => {
  if($(window).width() > 798) {
    var $keyFeatureWrapper = $('.jsc-key-feature-wrapper');
    if($keyFeatureWrapper.length > 0) {
      var $mediaList = $keyFeatureWrapper.find('.jsc-img-col .jsc-key-feature-media-item .jsc-media-box');

      $(window).on('scroll', function() {
        $($mediaList).each(function() {
          if($(this).hasClass('active')) {
            var currentIndex = parseInt($(this).parent().attr('data-index'));
            var elementOffset = $(this).offset().top;
            var scrollTop = $(window).scrollTop();
            var distance = elementOffset - scrollTop;

            // activate next slide
            if(distance < 70) { 
              var nextIndex = currentIndex + 1;
              var $nextMedia = $(this).parent().siblings('.jsc-key-feature-media-item[data-index="' + nextIndex + '"]');
              if($nextMedia.length > 0) {
                var $currentBg = $keyFeatureWrapper.find('.jsc-key-feature-bg[data-index="' + currentIndex + '"]');
                var $nextBg = $keyFeatureWrapper.find('.jsc-key-feature-bg[data-index="' + nextIndex + '"]');
                var $currentContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item[data-index="' + currentIndex + '"]');
                var $nextContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item[data-index="' + nextIndex + '"]');

                $nextMedia.find('.jsc-media-box').addClass('active');
                $(this).removeClass('active');
                $nextBg.addClass('active');
                $currentBg.removeClass('active');
                $nextContent.addClass('active');
                $currentContent.removeClass('active');
                updateContentPosition();
              }
            }

            // active previous slide
            if(distance > 400) { 
              var prevIndex = currentIndex - 1;
              var $prevMedia = $(this).parent().siblings('.jsc-key-feature-media-item[data-index="' + prevIndex + '"]');
              if($prevMedia.length > 0) {
                var $currentBg = $keyFeatureWrapper.find('.jsc-key-feature-bg[data-index="' + currentIndex + '"]');
                var $prevBg = $keyFeatureWrapper.find('.jsc-key-feature-bg[data-index="' + prevIndex + '"]');
                var $currentContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item[data-index="' + currentIndex + '"]');
                var $prevContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item[data-index="' + prevIndex + '"]');

                $prevMedia.find('.jsc-media-box').addClass('active');
                $(this).removeClass('active');
                $prevBg.addClass('active');
                $currentBg.removeClass('active');
                $prevContent.addClass('active');
                $currentContent.removeClass('active');
                updateContentPosition();
              }
            }
          }
        });
      });
    }
  }
}

handleContentScroll2 = () => {
  var $keyFeatureWrapper = $('.jsc-key-feature-wrapper');
  if($keyFeatureWrapper.length > 0) {
    var $mediaList = $keyFeatureWrapper.find('.jsc-img-col .jsc-key-feature-media-item .jsc-media-box');
    $(window).on('scroll', function() {
      var closestIndex = 1;
      var closestDistance = Number.MAX_VALUE;
      $($mediaList).each(function(index) {
        var distance = distanceFromViewportMiddle($(this));
        if (distance < closestDistance) {
          closestIndex = index + 1;
          closestDistance = distance;
        }
      });

      // closestIndex is the next index to change to
      var $mediaItemList = $keyFeatureWrapper.find('.jsc-img-col .jsc-key-feature-media-item');
      var $newActiveMedia = $mediaItemList.filter('[data-index="' + closestIndex + '"]');
      var $bgList = $keyFeatureWrapper.find('.jsc-key-feature-bg');
      var $newBg = $keyFeatureWrapper.find('.jsc-key-feature-bg[data-index="' + closestIndex + '"]');
      var $contentList = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item');
      var $newContent = $keyFeatureWrapper.find('.jsc-key-feature-content-list .jsc-key-feature-content-item[data-index="' + closestIndex + '"]');

      $mediaItemList.find('.jsc-media-box').removeClass('active');
      $newActiveMedia.find('.jsc-media-box').addClass('active');
      $bgList.removeClass('active');
      $newBg.addClass('active');
      $contentList.removeClass('active');
      $newContent.addClass('active');
      updateContentPosition();
    });
  }
}

distanceFromViewportMiddle = (el) => {
  const viewportMidY = window.scrollY + window.innerHeight / 2; 
  var docOffsetTop = $(el)[0].getBoundingClientRect().top + window.scrollY;
  const imageMidY = docOffsetTop + $(el).height() / 2; 

  return Math.abs(viewportMidY - imageMidY);
}

initKeyFeatureMobileSlider = () => {
  var $slider = $('.jsc-key-feature-mobile-slider-container');
  if($slider.length > 0) {
    $($slider).flickity({
      cellAlign: 'left',
      wrapAround: false,
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: false
    });

    setTimeout(() => {
      $($slider).find('.jsc-key-feature-mobile-slide').css('height', '100%');
    }, 1000);
  }
}
// end: key feature

// start: hotspot section
activateHotspot = (e) => {
  deactivateHotspot($(e));
  var $hotspot = $(e).parent();
  var $card = $(e).siblings('.jsc-hotspot-card');
  $(e).toggleClass('active');
  $hotspot.toggleClass('active');
  $card.toggleClass('active');
}

deactivateHotspot = (e) => {
  var $otherHotspot = $(e).parent().siblings('.jsc-hotspot');
  var $otherBtnList = $($otherHotspot).find('.jsc-hotspot-trigger-btn');
  var $otherCardList = $($otherHotspot).find('.jsc-hotspot-card');
  $otherHotspot.removeClass('active');
  $otherBtnList.removeClass('active');
  $otherCardList.removeClass('active');
}

updateMobileCardPos = () => {
  var $hotspotWrapper = $('.jsc-hotspots-wrapper');
  if($hotspotWrapper.length > 0 && $(window).width() <= 820) {
    var $cardList = $($hotspotWrapper).find('.jsc-hotspot-card');
    $cardList.each(function() {
      var buttonRect = $(this).siblings('.jsc-hotspot-trigger-btn')[0].getBoundingClientRect();
      var windowWidth = $(window).width();
      var rightOffset = $(this)[0].clientWidth / 2;
      $(this).css('right', 'calc(50% - ' + rightOffset + 'px)');
      var cardRect = $(this)[0].getBoundingClientRect();

      var naturalLeft = buttonRect.left + buttonRect.width / 2 - cardRect.width / 2;
      if(naturalLeft < 10) {
        $(this).css('right', `calc(50% - ${rightOffset - naturalLeft}px - 16px)`);
      }
      else {
        var naturalRight = buttonRect.left + buttonRect.width / 2 + cardRect.width / 2;
        if (naturalRight > windowWidth - 10) {
          $(this).css('right', `calc(50% - ${rightOffset - (naturalRight - windowWidth)}px + 16px)`);
        }
      }
    })
  }
}
// end: hotspot section
// start: shop the look
initCustomProductSlider = () => {
  var $shopTheLook = $('.jsc-shop-the-look-wrapper');
  if($shopTheLook.length > 0 && $(window).width() > 798) {
    $shopTheLook.each(function() {
      var $this = $(this);
      var $sliderNav = $($this).find('.jsc-product-slider-nav');
      if($sliderNav.length > 0) {
        var $prevBtn = $($sliderNav).find('.jsc-product-slider-nav-btn.jsc-nav-previous');
        var $nextBtn = $($sliderNav).find('.jsc-product-slider-nav-btn.jsc-nav-next');
  
        $prevBtn.on('click', function() {
          var $activeSlide = $($this).find('.jsc-product-slide.active');
          var activeIndex = parseInt($activeSlide.attr('data-index'));
          var newIndex = activeIndex - 1;
          var $newSlide = $($activeSlide).siblings('.jsc-product-slide[data-index="' + newIndex + '"]');
  
          if($newSlide.length > 0) {
            $activeSlide.removeClass('active');
            $newSlide.addClass('active');
          }
        });
  
        $nextBtn.on('click', function() {
          var $activeSlide = $($this).find('.jsc-product-slide.active');
          var activeIndex = parseInt($activeSlide.attr('data-index'));
          var newIndex = activeIndex + 1;
          var $newSlide = $($activeSlide).siblings('.jsc-product-slide[data-index="' + newIndex + '"]');
  
          if($newSlide.length > 0) {
            $activeSlide.removeClass('active');
            $newSlide.addClass('active');
          }
        });
      }
    });
  }
}

initMobileProductSlider = () => {
  var $shopTheLook = $('.jsc-shop-the-look-wrapper');
  if($shopTheLook.length > 0 && $(window).width() <= 798) {
    var $slider = $($shopTheLook).find('.jsc-product-slider');
    $($slider).flickity({
      cellAlign: 'left',
      wrapAround: false,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: false
    });
  }
}
// end: shop the look

//start: side cart drawer
jscInitCartDrawerOverlay = () => {
  if (jscCartOverlayBound) {
    return;
  }
  jscCartOverlayBound = true;
  $(document).on('click', '.jsc-cart-drawer-overlay', function() {
    jscCloseCartDrawer();
  });
};

jscOpenCartDrawer = () => {
  $('.jsc-cart-drawer-div').addClass('open-cart-drawer');
  $('.jsc-cart-drawer-overlay').removeClass('d-none');
  $('body').css({
    overflow: 'hidden'
  });
}
jscCloseCartDrawer = () => {
  $('.jsc-cart-drawer-div').removeClass('open-cart-drawer');
  $('.jsc-cart-drawer-overlay').addClass('d-none');
  $('body').css({
    overflow: 'scroll'
  });
}
jscEscapeHtml = (value) => {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
jscGetCartDrawerDiscountIconMarkup = () => {
  var $discountTemplate = $('.jsc-cart-items-section .jsc-cart-drawer-discount-template').first();
  if ($discountTemplate.length > 0) {
    return $discountTemplate.find('.cart-discount__icon').html();
  }
  return '';
}
jscShouldShowCartDrawerDiscount = ($discountTitle, isFreeGiftLine) => {
  if (!$discountTitle) {
    return false;
  }
  var $normalizedTitle = String($discountTitle).trim().toLowerCase();
  if ($normalizedTitle === 'free gift' || $normalizedTitle.indexOf('free gift') !== -1) {
    return !!isFreeGiftLine;
  }
  return true;
}
jscRefreshCartLineItemDiscounts = ($lineItem, $itemDiscountAllocations, isFreeGiftLine) => {
  if (!$lineItem || $lineItem.length === 0) {
    return;
  }
  if (!Array.isArray($itemDiscountAllocations)) {
    $itemDiscountAllocations = [];
  }
  var $prodVarTitle = $lineItem.find('.cart-line-item-prod-var-title').first();
  if ($prodVarTitle.length === 0) {
    return;
  }
  $lineItem.find('.jsc-cart-drawer-discount').remove();
  if (isFreeGiftLine) {
    return;
  }
  var $discountIconMarkup = jscGetCartDrawerDiscountIconMarkup();
  for (var k = 0; k < $itemDiscountAllocations.length; k++) {
    var $discountAllocation = $itemDiscountAllocations[k];
    var $discountTitle = '';
    if ($discountAllocation && $discountAllocation.discount_application && $discountAllocation.discount_application.title) {
      $discountTitle = $discountAllocation.discount_application.title;
    } else if ($discountAllocation && $discountAllocation.title) {
      $discountTitle = $discountAllocation.title;
    }
    if (jscShouldShowCartDrawerDiscount($discountTitle, isFreeGiftLine)) {
      $prodVarTitle.append(
        '<div class="cart-discount__label jsc-cart-drawer-discount">' +
          '<span class="cart-discount__icon">' + $discountIconMarkup + '</span>' +
          '<span class="cart-discount__title">' + jscEscapeHtml($discountTitle) + '</span>' +
        '</div>'
      );
    }
  }
}
jscGetCartVariantCounts = ($cartItems) => {
  var $counts = {};
  for (var i = 0; i < $cartItems.length; i++) {
    var $variantId = String($cartItems[i].id);
    $counts[$variantId] = ($counts[$variantId] || 0) + 1;
  }
  return $counts;
}
jscFindCartDrawerLineItem = ($cartDrawerItems, $itemKey, $itemID, $allowVariantFallback) => {
  var $lineItem = null;
  var $variantMatches = [];

  $cartDrawerItems.children('.jsc-cart-line-items:not(.jsc-dummy-cart-line-items)').each(function() {
    if ($itemKey && $(this).attr('data-key') === $itemKey) {
      $lineItem = $(this);
      return false;
    }
    if ($allowVariantFallback && String($(this).attr('data-var-id')) === String($itemID)) {
      $variantMatches.push($(this));
    }
  });

  if (!$lineItem && $allowVariantFallback && $variantMatches.length === 1) {
    $lineItem = $variantMatches[0];
  }

  return $lineItem;
}
jscGetCartDrawerLineItemUpdateId = ($lineItem) => {
  if (!$lineItem || $lineItem.length === 0) {
    return null;
  }
  return $lineItem.attr('data-key') || $lineItem.attr('data-var-id');
}
jscRestoreCartDrawerQuantitySelector = ($lineItem, $itemQty) => {
  var $qtySelector = $lineItem.find('.jsc-qty-selector').first();
  if ($qtySelector.length === 0) {
    return;
  }

  $qtySelector.removeClass('jsc-cart-drawer-free-gift-label');
  $qtySelector.find('.jsc-cart-drawer-free-gift-span').remove();
  $qtySelector.find('.jsc-cart-drawer-gwp-fixed-qty').remove();

  if ($qtySelector.find('.quantity').length > 0) {
    $qtySelector.find('.cart-item__quantity-input').val($itemQty);
    if ($itemQty > 1) {
      $qtySelector.find('.minus').removeClass('unusable');
    } else {
      $qtySelector.find('.minus').addClass('unusable');
    }
    return;
  }

  var $quantityTemplate = $('.jsc-dummy-cart-line-items .quantity').first();
  if ($quantityTemplate.length === 0) {
    return;
  }

  $qtySelector.append($quantityTemplate.clone());
  $qtySelector.find('.cart-item__quantity-input').val($itemQty);
  if ($itemQty > 1) {
    $qtySelector.find('.minus').removeClass('unusable');
  } else {
    $qtySelector.find('.minus').addClass('unusable');
  }
}
jscRenderCartDrawer = (data, options) => {
  options = options || {};
  var $cartItems = data.items;
  var $cartDrawerItems = $('.jsc-cart-items-section');
  var $variantCounts = jscGetCartVariantCounts($cartItems);
  var $hasDuplicateVariants = false;
  var shouldOpenDrawer = false;

  Object.keys($variantCounts).forEach(function($variantId) {
    if ($variantCounts[$variantId] > 1) {
      $hasDuplicateVariants = true;
    }
  });

  for (var i = 0; i < $cartItems.length; i++) {
    var $itemID = $cartItems[i].id;
    var $itemQty = $cartItems[i].quantity;
    var $itemProdTitle = $cartItems[i].product_title;
    var $itemVarOpt = $cartItems[i].options_with_values;
    var $itemUrl = $cartItems[i].url;
    var $itemImage = $cartItems[i].featured_image.url;
    var $itemImageAlt = $cartItems[i].featured_image.alt;
    var $itemPrice = $cartItems[i].price;
    var $itemFinalPrice = parseInt($cartItems[i].final_price, 10);
    var $itemOriginalPrice = parseInt($cartItems[i].original_price, 10);
    var $itemDiscountAllocations = $cartItems[i].line_level_discount_allocations || [];
    var $itemKey = $cartItems[i].key;
    var $itemProperties = $cartItems[i].properties || {};
    var $isFreeGiftLine = jscIsCartDrawerFreeGiftLine($itemProperties, $itemFinalPrice);
    var $isGwpLockedQtyLine = jscIsCartDrawerGwpLockedQtyLine($itemProperties, $itemFinalPrice);
    if (!Array.isArray($itemDiscountAllocations)) {
      $itemDiscountAllocations = [];
    }
    if (isNaN($itemFinalPrice)) {
      $itemFinalPrice = parseInt($itemPrice, 10);
    }

    if (jscIsCartLineItemPendingRemoval($itemKey, $itemID)) {
      continue;
    }

    var $allowVariantFallback = $variantCounts[String($itemID)] === 1;
    var $drawerLineItem = jscFindCartDrawerLineItem($cartDrawerItems, $itemKey, $itemID, $allowVariantFallback);
    if ($drawerLineItem && $drawerLineItem.length > 0) {
      $drawerLineItem.attr('data-key', $itemKey);
      if ($isFreeGiftLine) {
        jscApplyCartDrawerFreeGiftLabel($drawerLineItem, true, $itemKey);
      } else if ($isGwpLockedQtyLine) {
        jscApplyCartDrawerGwpFixedQuantity($drawerLineItem, $itemKey);
      } else {
        jscRestoreCartDrawerQuantitySelector($drawerLineItem, $itemQty);
        $drawerLineItem.find('.cart-line-item-remove').attr('onclick', 'jscRemoveItemCartDrawer(this);');
      }
      jscRefreshCartLineItemDiscounts($drawerLineItem, $itemDiscountAllocations, $isFreeGiftLine);
    } else {
      jscCreateCartGrid($itemID,$itemQty,$itemProdTitle,$itemVarOpt,$itemUrl,$itemImage,$itemImageAlt,$itemPrice,$itemFinalPrice,$itemOriginalPrice,$itemDiscountAllocations,$itemProperties,$itemKey,$isFreeGiftLine,$isGwpLockedQtyLine);
      shouldOpenDrawer = true;
    }
  }

  var $cartKeys = {};
  for (var c = 0; c < $cartItems.length; c++) {
    if ($cartItems[c].key) {
      $cartKeys[$cartItems[c].key] = true;
    }
    $cartKeys[String($cartItems[c].id)] = true;
  }
  $cartDrawerItems.children('.jsc-cart-line-items:not(.jsc-dummy-cart-line-items)').each(function() {
    var $drawerKey = $(this).attr('data-key');
    var $drawerVarId = String($(this).attr('data-var-id'));
    if (jscIsCartLineItemPendingRemoval($drawerKey, $drawerVarId)) {
      return;
    }
    var $isInCart = ($drawerKey && $cartKeys[$drawerKey]) || (!$hasDuplicateVariants && $cartKeys[$drawerVarId]);
    if (!$isInCart) {
      $(this).remove();
    }
  });
  jscClearResolvedCartRemovals($cartItems);

  if (options.isGwpInCart === true) {
    var $giftLineKey = $('.jsc-cart-gift-remove.jsc-promo-1').val();
    if ($giftLineKey) {
      $cartDrawerItems.children('.jsc-cart-line-items:not(.jsc-dummy-cart-line-items)').each(function() {
        if ($(this).attr('data-key') === $giftLineKey) {
          $(this).remove();
        }
      });
    }
  }

  calculateProgress(data);
  calculateProgressGWP(data, { uiOnly: true });

  var $drawerHeader = $('.jsc-cart-drawer-header');
  $('.cart-link').find('.cart-link__count').html(data.item_count);
  $drawerHeader.find('.cart-drawer-qty').html(data.item_count);

  var $drawerFooter = $('.jsc-cart-drawer-footer');
  var format_CartPrice = Shopify.formatMoney(data.total_price, $('body').data('money'));
  var currency_CartPrice = format_CartPrice.replace('undefined','$');
  $drawerFooter.find('.jsc-cart-drawer-total').html(currency_CartPrice).removeClass('jsc-updating');

  jscLastCartSnapshot = {
    item_count: data.item_count,
    total_price: data.total_price
  };

  if (shouldOpenDrawer || options.openAfterRender || options.openDrawer) {
    jscOpenCartDrawer();
  }

  if (options.openAfterRender) {
    jscPendingDrawerOpen = false;
  }

  $('.jsc-cart-drawer-div').removeClass('jsc-cart-updating');
};

jscUpdateCartDrawer = (cartDataOrVarID, optionsOrLegacy) => {
  var cartData = null;
  var options = {};

  if (typeof optionsOrLegacy === 'object' && optionsOrLegacy !== null) {
    options = optionsOrLegacy;
  } else if (typeof optionsOrLegacy !== 'undefined') {
    options.isGwpInCart = optionsOrLegacy;
  }

  if (typeof cartDataOrVarID === 'object' && cartDataOrVarID !== null && cartDataOrVarID.items) {
    cartData = cartDataOrVarID;
  } else if (cartDataOrVarID) {
    options.openDrawer = true;
  }

  clearTimeout(jscUpdateCartDrawerTimer);

  var renderDrawer = function() {
    if (cartData) {
      jscRenderCartDrawer(cartData, options);
      return;
    }

    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(data) {
        jscRenderCartDrawer(data, options);
      });
  };

  if (cartData && options.openAfterRender) {
    renderDrawer();
    return;
  }

  jscUpdateCartDrawerTimer = setTimeout(renderDrawer, cartData ? 50 : 200);
}
jscIsCartLineItemPendingRemoval = (itemKey, itemID) => {
  var $pendingAt = null;
  if (itemKey && jscPendingCartRemovals[itemKey]) {
    $pendingAt = jscPendingCartRemovals[itemKey];
  } else if (itemID && jscPendingCartRemovals[String(itemID)]) {
    $pendingAt = jscPendingCartRemovals[String(itemID)];
  }
  if (!$pendingAt) {
    return false;
  }
  if (Date.now() - $pendingAt > jscPendingCartRemovalMs) {
    return false;
  }
  return true;
}
jscMarkCartLineItemPendingRemoval = (itemKey, itemID) => {
  var $now = Date.now();
  if (itemKey) {
    jscPendingCartRemovals[itemKey] = $now;
  }
  if (itemID) {
    jscPendingCartRemovals[String(itemID)] = $now;
  }
}
jscClearResolvedCartRemovals = ($cartItems) => {
  var $cartKeys = {};
  for (var p = 0; p < $cartItems.length; p++) {
    if ($cartItems[p].key) {
      $cartKeys[$cartItems[p].key] = true;
    }
    $cartKeys[String($cartItems[p].id)] = true;
  }
  Object.keys(jscPendingCartRemovals).forEach(function($pendingKey) {
    if (!$cartKeys[$pendingKey]) {
      delete jscPendingCartRemovals[$pendingKey];
    }
  });
}
jscIsCartGiftLineItem = (properties) => {
  if (!properties) {
    return false;
  }
  var $cartGiftProp = properties['_Cart_Gift'];
  if ($cartGiftProp !== undefined && $cartGiftProp !== null && String($cartGiftProp) !== '') {
    return true;
  }
  return properties['_Cart_GWP'] === 'Free Gift';
}
jscIsCartDrawerFreeGiftLine = (properties, finalPrice) => {
  if (!properties || properties['_Cart_GWP'] !== 'Free Gift') {
    return false;
  }
  var $price = parseInt(finalPrice, 10);
  return !isNaN($price) && $price === 0;
}
jscIsCartDrawerGwpLockedQtyLine = (properties, finalPrice) => {
  if (!properties || properties['_Cart_GWP'] !== 'Free Gift') {
    return false;
  }
  return !jscIsCartDrawerFreeGiftLine(properties, finalPrice);
}
jscApplyCartDrawerGwpFixedQuantity = ($lineItem, itemKey) => {
  if (!$lineItem || $lineItem.length === 0) {
    return;
  }

  var $qtySelector = $lineItem.find('.jsc-qty-selector.cart-line-item-qty').first();
  if ($qtySelector.length === 0) {
    $qtySelector = $lineItem.find('.jsc-qty-selector').first();
  }
  if ($qtySelector.length === 0) {
    return;
  }

  $lineItem.attr('data-gwp', 'true');
  $qtySelector.removeClass('jsc-cart-drawer-free-gift-label');
  $qtySelector.find('.jsc-cart-drawer-free-gift-span').remove();
  $qtySelector.find('.quantity').remove();
  if ($qtySelector.find('.jsc-cart-drawer-gwp-fixed-qty').length === 0) {
    $qtySelector.append('<span class="jsc-cart-drawer-gwp-fixed-qty">1</span>');
  } else {
    $qtySelector.find('.jsc-cart-drawer-gwp-fixed-qty').text('1');
  }
  if (itemKey) {
    $lineItem.find('.cart-line-item-remove').attr(
      'onclick',
      "jscRemoveItemCartDrawer(this);removeFreeGift(this,'" + itemKey + "')"
    );
  }
}
jscApplyCartDrawerFreeGiftLabel = ($lineItem, isFreeGift, itemKey) => {
  if (!$lineItem || $lineItem.length === 0) {
    return;
  }

  var $qtySelector = $lineItem.find('.jsc-qty-selector.cart-line-item-qty').first();
  if ($qtySelector.length === 0) {
    $qtySelector = $lineItem.find('.jsc-qty-selector').first();
  }
  if ($qtySelector.length === 0) {
    return;
  }

  if (isFreeGift) {
    $lineItem.attr('data-gwp', 'true');
    $qtySelector.addClass('jsc-cart-drawer-free-gift-label');
    $qtySelector.find('.jsc-cart-drawer-gwp-fixed-qty').remove();
    $qtySelector.find('.quantity').remove();
    if ($qtySelector.find('.jsc-cart-drawer-free-gift-span').length === 0) {
      $qtySelector.append('<span class="jsc-cart-drawer-free-gift-span">FREE GIFT</span>');
    }
    if (itemKey) {
      $lineItem.find('.cart-line-item-remove').attr(
        'onclick',
        "jscRemoveItemCartDrawer(this);removeFreeGift(this,'" + itemKey + "')"
      );
    }
  } else {
    $lineItem.attr('data-gwp', 'false');
  }
}
jscCreateCartGrid = ($itemID,$itemQty,$itemProdTitle,$itemVarOpt,$itemUrl,$itemImage,$itemImageAlt,$itemPrice,$itemFinalPrice,$itemOriginalPrice,$itemDiscountAllocations,$itemProperties,$itemKey,$isFreeGiftLine,$isGwpLockedQtyLine) => {
  //console.log($itemID,$itemQty,$itemProdTitle,$itemVarOpt,$itemUrl,$itemImage,$itemImageAlt,isGwpInCart);
  var $displayItemPrice = parseInt($itemFinalPrice, 10);
  if (isNaN($displayItemPrice)) {
    $displayItemPrice = parseInt($itemPrice, 10);
  }
  if (isNaN($displayItemPrice) || $displayItemPrice < 0) {
    $displayItemPrice = 0;
  }
  var format_varPrice = Shopify.formatMoney($displayItemPrice, $('body').data('money'));
  var currency_varPrice = format_varPrice.replace('undefined','$');
  var $cloneGrid = $('.jsc-cart-items-section').find('.jsc-dummy-cart-line-items.jsc-cart-line-items').first().clone();
  var $getVarDetails = $('.jsc-product-variant-details');
  var $thisMaxQty;
  var $variantPrice = parseInt($itemPrice, 10);
  var $variantCompareAtPrice = 0;

  $getVarDetails.children().each(function(){
    var $thisID = $(this).attr('data-var-id');
    if ($itemID == $thisID) {
      $thisMaxQty = $(this).attr('data-max-qty');
      var $thisPrice = parseInt($(this).attr('data-price'), 10);
      var $thisCompareAtPrice = parseInt($(this).attr('data-compare-at-price'), 10);
      $cloneGrid.find('.jsc-product-details-input').attr('data-max-qty',$thisMaxQty);
      if (!isNaN($thisPrice) && $thisPrice > 0) {
        $variantPrice = $thisPrice;
      }
      if (!isNaN($thisCompareAtPrice) && $thisCompareAtPrice > 0) {
        $variantCompareAtPrice = $thisCompareAtPrice;
      }
      if ($thisMaxQty <= 1) {
        $cloneGrid.find('.jsc-qty-selector .plus').addClass('unusable');
      }
    }
  });

  $cloneGrid.find('.cart-line-item-img a').attr('href',$itemUrl);
  $cloneGrid.find('.cart-line-item-img img').attr('src',$itemImage);
  $cloneGrid.find('.cart-line-item-img img').attr('alt',$itemImageAlt);
  $cloneGrid.find('.cart-line-item-prod-title a').text($itemProdTitle);
  $cloneGrid.attr('data-var-id',$itemID);
  $cloneGrid.attr('data-key',$itemKey);
  $cloneGrid.attr('data-gwp','false');
  $cloneGrid.find('.cart-line-item-var-title').remove();
  $cloneGrid.find('.jsc-cart-drawer-discount').remove();
  $cloneGrid.find('.jsc-qty-selector input').val($itemQty);
  $cloneGrid.find('.jsc-qty-selector .quantity-down').addClass('unusable');
  if ($isFreeGiftLine) {
    jscApplyCartDrawerFreeGiftLabel($cloneGrid, true, $itemKey);
  } else if ($isGwpLockedQtyLine) {
    jscApplyCartDrawerGwpFixedQuantity($cloneGrid, $itemKey);
  }

  var $priceContainer = $cloneGrid.find('.cart-line-item-price');
  var $variantPriceContainer = $priceContainer.find('.jsc-variant-price');
  $priceContainer.find('.struck-out-price').remove();
  $variantPriceContainer.removeClass('jsc-sale-price');

  var hasSalePrice = false;
  var strikeOutPriceMarkup = '';
  if ($variantCompareAtPrice > $variantPrice) {
    var format_compareAtPrice = Shopify.formatMoney($variantCompareAtPrice, $('body').data('money'));
    var currency_compareAtPrice = format_compareAtPrice.replace('undefined','$');
    strikeOutPriceMarkup += '<div class="struck-out-price"><span class="theme-money">' + currency_compareAtPrice + '</span></div>';
    hasSalePrice = true;
  }
  if (!isNaN($itemOriginalPrice) && $itemOriginalPrice > $displayItemPrice) {
    var format_originalPrice = Shopify.formatMoney($itemOriginalPrice, $('body').data('money'));
    var currency_originalPrice = format_originalPrice.replace('undefined','$');
    strikeOutPriceMarkup += '<div class="struck-out-price"><span class="theme-money">' + currency_originalPrice + '</span></div>';
    hasSalePrice = true;
  }
  if (strikeOutPriceMarkup !== '') {
    $priceContainer.prepend(strikeOutPriceMarkup);
  }
  if (hasSalePrice) {
    $variantPriceContainer.addClass('jsc-sale-price');
  }

  $cloneGrid.find('.cart-line-item-price .jsc-variant-price .theme-money').text(currency_varPrice);
  //console.log('currency_varPrice',currency_varPrice);
  for (var j = 0; j < $itemVarOpt.length; j++) {
    var $itemVarTitle = $itemVarOpt[j].name + ': ' + $itemVarOpt[j].value;

    $cloneGrid.find('.cart-line-item-prod-var-title').append('<div class="cart-line-item-var-title">' + $itemVarTitle + '</div>');
  }
  $cloneGrid.find('.jsc-cart-drawer-discount-template').remove();
  jscRefreshCartLineItemDiscounts($cloneGrid, $itemDiscountAllocations, $isFreeGiftLine);
  $cloneGrid.removeClass('d-none').removeClass('jsc-dummy-cart-line-items');
  $cloneGrid.insertAfter('.jsc-dummy-cart-line-items.jsc-cart-line-items');
}
//end: side cart drawer

//start: calculate free shipping
calculateProgress = (cartOrTotal) => {
  var freeDeliverySection = $('.jsc-cart-freedelivery-section');
  if (freeDeliverySection.length === 0) {
    return;
  }

  var cartMinText = freeDeliverySection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText, 10);
  var progressBar = freeDeliverySection.find('.cart-shippingThreshold__progress');
  var progressNum = freeDeliverySection.find('.cart-shipping__num');
  var progressOuter = freeDeliverySection.find('.cart-shipping__numOuter');
  var successMsg = freeDeliverySection.find('.cart-shipping__success');

  var applyProgress = function(_totalPrice) {
    if (_totalPrice > 0) {
      freeDeliverySection.removeClass('d-none');
      var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
      var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
      if (progressWidth >= 100) {
        progressWidth = 100;
      }
      var progressWidthPercent = progressWidth.toString() + '%';

      progressBar.each(function() {
        $(this).css({
          width: progressWidthPercent
        });
      });

      if (_totalPrice >= cartMinVal) {
        progressOuter.hide();
        successMsg.show();
      } else {
        progressNum.text(calcFreeDeliveryVal);
        progressOuter.show();
        successMsg.hide();
      }
    } else {
      freeDeliverySection.addClass('d-none');
    }
  };

  if (typeof cartOrTotal === 'object' && cartOrTotal !== null) {
    applyProgress(cartOrTotal.total_price);
    return;
  }

  if (typeof cartOrTotal === 'number') {
    applyProgress(cartOrTotal);
    return;
  }

  fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      applyProgress(cart.total_price);
    });
};
//end: calculate free shipping

//start: cart drawer qty selector
jscGetCartDrawerLineItemMaxQty = ($lineItem) => {
  var maxQty = parseInt($lineItem.find('.jsc-product-details-input').attr('data-max-qty'), 10);
  if (!isNaN(maxQty) && maxQty > 0) {
    return maxQty;
  }

  maxQty = parseInt($lineItem.find('.cart-item__quantity-input').attr('data-max'), 10);
  if (!isNaN(maxQty) && maxQty > 0) {
    return maxQty;
  }

  return null;
};

jscSyncCartDrawerQuantityControls = ($lineItem, count, maxQty) => {
  var $qtyWrap = $lineItem.find('.quantity.buttoned-input');
  var $minus = $qtyWrap.find('.minus');
  var $plus = $qtyWrap.find('.plus');

  if (count <= 1) {
    $minus.addClass('unusable');
  } else {
    $minus.removeClass('unusable');
  }

  if (maxQty && count >= maxQty) {
    $plus.addClass('unusable');
  } else {
    $plus.removeClass('unusable');
  }
};

jscInitCartDrawerQtyInputs = () => {
  $(document).on('focus', '.jsc-cart-drawer-section .cart-item__quantity-input', function() {
    var currentQty = parseInt($(this).val(), 10);
    $(this).data('jsc-prev-qty', isNaN(currentQty) ? 1 : currentQty);
  });

  $(document).on('change', '.jsc-cart-drawer-section .cart-item__quantity-input', function(evt) {
    if (!evt.originalEvent) {
      return;
    }
    jscChangeItemCartDrawerInput(this);
  });
};

jscChangeItemCartDrawerInput = (input) => {
  var $input = $(input);
  var $lineItem = $input.closest('.jsc-cart-line-items');

  if ($lineItem.length === 0 || $lineItem.hasClass('jsc-dummy-cart-line-items') || $lineItem.attr('data-gwp') === 'true') {
    return;
  }

  var maxQty = jscGetCartDrawerLineItemMaxQty($lineItem);
  var previousValue = parseInt($input.data('jsc-prev-qty'), 10);
  var count = parseInt($input.val(), 10);

  if (isNaN(count) || count < 1) {
    count = !isNaN(previousValue) && previousValue >= 1 ? previousValue : 1;
  }

  if (maxQty && count > maxQty) {
    count = maxQty;
  }

  $input.val(count);
  jscSyncCartDrawerQuantityControls($lineItem, count, maxQty);

  var $updateId = jscGetCartDrawerLineItemUpdateId($lineItem);
  if (!$updateId) {
    return;
  }

  if (!isNaN(previousValue) && count === previousValue) {
    return;
  }

  $input.data('jsc-prev-qty', count);
  jscDebounceCartQtyUpdate($updateId, count, $lineItem);
};

jscDebounceCartQtyUpdate = (updateId, count, $lineItem) => {
  if (!updateId) {
    return;
  }
  clearTimeout(jscCartQtyDebounceTimers[updateId]);
  $lineItem.addClass('jsc-cart-line-updating');
  jscCartQtyDebounceTimers[updateId] = setTimeout(function() {
    delete jscCartQtyDebounceTimers[updateId];
    $lineItem.removeClass('jsc-cart-line-updating');
    cartJSUpdateQuery(updateId, count, {}, true);
  }, jscCartQtyDebounceMs);
};

jscUpdateCartCountsOptimistic = (delta) => {
  var $drawerQty = $('.cart-drawer-qty');
  var current = parseInt($drawerQty.text(), 10) || 0;
  var newCount = Math.max(0, current + delta);
  $('.cart-link').find('.cart-link__count').html(newCount);
  $drawerQty.html(newCount);
};

jscMinusItemCartDrawer = (e) => {
  var $input = $(e).parent().find('input');
  var count = parseInt($input.val(), 10) - 1;
  var $maxQty = jscGetCartDrawerLineItemMaxQty($(e).parents('.jsc-cart-line-items'));
  var $thisPlus = $(e).parent().find('.plus');
  count = count < 1 ? 1 : count;
  $input.val(count);

  var $lineItem = $(e).parents('.jsc-cart-line-items');
  var $updateId = jscGetCartDrawerLineItemUpdateId($lineItem);
  if (count >= 1) {
    $(e).removeClass('unusable');
    jscDebounceCartQtyUpdate($updateId, count, $lineItem);
  }
  if (count == 1) {
    $(e).addClass('unusable');
  }

  if (!$maxQty || $input.val() < $maxQty) {
    $thisPlus.removeClass('unusable');
  }
}
jscPlusItemCartDrawer = (e) => {
  var $input = $(e).parent().find('input');
  var $thisMinus = $(e).parent().find('.minus');
  var $lineItem = $(e).parents('.jsc-cart-line-items');
  var $maxQty = jscGetCartDrawerLineItemMaxQty($lineItem);
  var $inputValueInt = parseInt($input.val(), 10);

  if (!$maxQty || $inputValueInt < $maxQty) {
    var count = parseInt($input.val(), 10) + 1;
    $input.val(count);
    $thisMinus.removeClass('unusable');

    var $updateId = jscGetCartDrawerLineItemUpdateId($lineItem);

    jscDebounceCartQtyUpdate($updateId, count, $lineItem);
    if ($maxQty && $input.val() >= $maxQty) {
      $(e).addClass('unusable');
    }
  }
}
jscRemoveItemCartDrawer = (e) => {
  var $lineItem = $(e).parents('.jsc-cart-line-items');
  var $vid = $lineItem.attr('data-var-id');
  var $key = $lineItem.attr('data-key');
  var $isGwp = $lineItem.attr('data-gwp');
  var $updateId = jscGetCartDrawerLineItemUpdateId($lineItem);

  if ($updateId && jscCartQtyDebounceTimers[$updateId]) {
    clearTimeout(jscCartQtyDebounceTimers[$updateId]);
    delete jscCartQtyDebounceTimers[$updateId];
  }

  jscMarkCartLineItemPendingRemoval($key, $vid);
  jscUpdateCartCountsOptimistic(-1);
  $('.jsc-cart-drawer-footer .jsc-cart-drawer-total').addClass('jsc-updating');

  $lineItem.addClass('removing');
  setTimeout(function() {
    $lineItem.remove();
  }, 200);

  if ($isGwp == 'true') {
    sessionStorage.setItem("FreeGift", "Remove");
  }

  cartJSUpdateQuery($updateId, 0, {}, true);
}
//end: side cart drawer

//start: calculate free gift GWP progress bar
calculateProgressGWP = (cartOrTotal, options) => {
  options = options || {};
  var freeGiftSection = $('.jsc-cart-freegift-section');
  if (freeGiftSection.length === 0) {
    return;
  }

  var cartMinText = freeGiftSection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText, 10);
  var progressBar = freeGiftSection.find('.cart-shippingThreshold__progress');
  var progressNum = freeGiftSection.find('.cart-shipping__num');
  var progressOuter = freeGiftSection.find('.cart-shipping__numOuter');
  var successMsg = freeGiftSection.find('.cart-shipping__success');
  var freeItemId = freeGiftSection.find('.cart-shipping__wrapper').attr('data-item-id');

  var applyGwpProgress = function(cart) {
    var _totalPrice = cart.total_price;
    var $cartItems = cart.items || [];
    var isGwpInCart = false;

    for (var i = 0; i < $cartItems.length; i++) {
      var $itemID = $cartItems[i].id;
      var $itemGwpProp = $cartItems[i].properties && $cartItems[i].properties['_Cart_GWP'];
      var $itemGwpPropPromo = $cartItems[i].properties && $cartItems[i].properties['_Cart_Gift'];

      if (String(freeItemId) == String($itemID) && $itemGwpProp == 'Free Gift' && String($itemGwpPropPromo) == '1') {
        isGwpInCart = true;
      }
    }

    if (_totalPrice > 0) {
      freeGiftSection.removeClass('d-none');
      var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
      var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
      if (progressWidth >= 100) {
        progressWidth = 100;
      }
      var progressWidthPercent = progressWidth.toString() + '%';

      progressBar.each(function() {
        $(this).css({
          width: progressWidthPercent
        });
      });

      if (_totalPrice >= cartMinVal) {
        progressOuter.hide();
        successMsg.show();
        if (!isGwpInCart) {
          $('.jsc-cart-items-section .jsc-cart-gift').remove();
        }
      } else {
        progressNum.text(calcFreeDeliveryVal);
        progressOuter.show();
        successMsg.hide();
        $('.jsc-cart-items-section .jsc-cart-gift-remove.jsc-promo-1').remove();
      }
    } else {
      freeGiftSection.addClass('d-none');
    }
  };

  if (typeof cartOrTotal === 'object' && cartOrTotal !== null && cartOrTotal.items) {
    applyGwpProgress(cartOrTotal);
    return;
  }

  if (options.uiOnly && typeof cartOrTotal === 'object' && cartOrTotal !== null) {
    applyGwpProgress(cartOrTotal);
    return;
  }

  fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      applyGwpProgress(cart);
    });
};
jscUpdateShippingAndGWPbar = () => {
  setTimeout(function(){
    calculateProgress();
    calculateProgressGWP();
  },500);
}
//end: calculate free gift GWP progress bar

//start: hide size variant with variant metafield
onloadHideSizeVariant = () => {
  var $current_id = $('.price-descriptors').find('form [name="id"]').val();
  var $variant_info = $('.jsc-variant-details').find('input');
  var $variant_button = $('.jsc-pdp-size[data-option=Size]').find('input');
  var $main_button = $('.buy-buttons-row'); // ATC or notify me button

  $variant_info.each(function(){
    var $thisID = $(this).attr('data-var-id');
    var $thisQty = $(this).attr('data-var-stock');
    var $thisHide = $(this).attr('data-var-hide');
    var $thisSize = $(this).attr('data-var-size');
    var $thisAvail = $(this).attr('data-var-avail');

    if ($thisHide == 'true') {
      $variant_button.each(function(){
        var $btn_size = $(this).attr('value');
        if ($btn_size == $thisSize && $thisHide == 'true') {
          $(this).next().hide();
        }
      });
    }
  })
}
//end: hide size variant with variant metafield

//start: zoom image when click on the zoom icon
zoomImagePdp = (e) => {
  let activeImageLink = null;
  const gallery = e.closest('.jsc-product-gallery');

  if (gallery) {
    const isSlider = gallery.querySelector('.slick-initialized');

    if (isSlider && window.innerWidth <= 799) {
      activeImageLink = gallery.querySelector('.slick-slide.slick-current a.show-gallery');
    } else {
      activeImageLink = gallery.querySelector('.product-gallery__image a.show-gallery');
    }
    
    if (activeImageLink) {
      activeImageLink.click();
    }
  }
}
//end: zoom image when click on the zoom icon

//start: initiate flickity for image gallery in pdp
initFlickityImageGallery = () => {
  var $newGallery = $('.jsc-product-gallery__main').length;

  if ($(window).width() < 480) {
    if ($newGallery > 0) {
      //console.log('init flickity in mobile');
      $('.jsc-product-gallery__main').flickity({
        // options
        prevNextButtons : true,
        pageDots : false,
        wrapAround : true,
        contain: true,
        cellAlign: 'left',
        draggable: true,
        imagesLoaded : true,
        on: {
          ready: function() {
            $(this.element).addClass('jsc-flickity-initiated');
          }
        }
      });
    }
  }
  
}
//end: initiate flickity for image gallery in pdp